export default __webpack_public_path__ + "static/media/Belt of the Whispering Blade.00551a40.jpg";